<template>
  <div
    v-if="baseGroupCombosFiltered && baseGroupCombosFiltered.length > 0"
    class="variation-listing-filters-container"
  >
    <div
      v-for="group in baseGroupCombosFiltered"
      :key="group.variationGroupId"
      class="variation-listing-filters-group"
    >
      <GroupFilter
        v-if="isBaseGroup(group)"
        class="variation-listing-filters-group-wrapper"
        :group="group"
        :entries="group.variations"
        :is-base-group="isBaseGroup(group)"
      >
      </GroupFilter>
    </div>

  </div>
</template>

<script>
import GroupFilter from './GroupFilter'

export default {
  name: 'BaseGroupListingFilters',
  components: {
    GroupFilter
  },
  props: {
    baseGroupCombos: {
      type: Array
    }
  },
  computed: {
    baseGroupCombosFiltered () {
      return this.baseGroupCombos.filter((combo) => {
        return (combo.variationDisplayType !== 'text-range-per-count' && combo.variationDisplayType !== 'text-range-per-value') && this.shouldDisplayCombo(combo)
      })
    }
  },
  methods: {
    isBaseGroup (group) {
      return !(group.variationDisplayType === 'text-range-per-count' || group.variationDisplayType === 'text-range-per-value')
    },
    shouldDisplayCombo (combo) {
      return combo.variationGroupDisplayPosition === 0 || combo.variationGroupDisplayPosition === 2
    }
  }
}
</script>

<style lang="scss" scoped>
.variation-listing-filters-group {
  padding:15px;
  border-radius: 15px;
  -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1607843137);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1607843137);
  background-color: #fff;
}
</style>
